import { useState, useEffect } from 'react';
// import config from 'utils/config';
import ppc from './ppc';
import sales from './sales';
import pnl from './pnl';
import externalMenu from './externalMenu';
import groupBy from './groupBy';
import keywordTrackingMenu from './keywordTrackingMenu';
import { IconHelp } from '@tabler/icons';

const getMenuItems = () => {
  const userType = JSON.parse(localStorage.getItem('user_data'));
  const menuItems = {
    items: [ppc, sales, pnl, externalMenu, groupBy, keywordTrackingMenu]
  };

  if (userType?.data?.user_type == 1) {
    // Filter out Pages, Other, and Utilities groups that should not be shown to usertype 1
    menuItems.items = menuItems.items.filter((item) => item?.title !== 'PPC' && item?.title !== 'Sales' && item?.title !== 'PnL');
  } else {
    menuItems.items = menuItems.items.filter((item) => item?.title !== 'External');
  }
  menuItems?.items?.push({
    id: 'menu',
    title: '',
    type: 'group',
    children: [
      {
        id: 'help',
        title: 'Help Center',
        type: 'item',
        url: 'https://support.dashna.com/',
        icon: IconHelp,
        external: true,
        breadcrumbs: false,
        target: true,
        role: [2, 4]
      }
    ]
  });

  return menuItems;
};

export default function useMenuItems() {
  const [menuItems, setMenuItems] = useState(getMenuItems());

  useEffect(() => {
    function handleStorageChange() {
      // Update menuItems when userType changes in localStorage
      setMenuItems(getMenuItems());
    }

    // Listen for changes in localStorage
    window.addEventListener('storage', handleStorageChange);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []); // Empty dependency array ensures that this effect runs only once on mount

  return menuItems;
}
